// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const HttpMethodSchema = z.enum(['GET','POST','PUT','DELETE','PATCH'] as const);

export type HttpMethodType = `${z.infer<typeof HttpMethodSchema>}`

export default HttpMethodSchema;
